import * as yup from "yup";

import { CustomerCardFormType } from "@/components/features/ToDos/CustomerCardPage/formType";
import {
    CustomerCardDriverLicenseFormType,
    CustomerCardIdentityFormType,
    CustomerCardPersonalFormType,
} from "@/components/features/ToDos/CustomerCardPage/steps/DetailsStep/formType";
import { Shape } from "@/core/yup";
import { AddressMaxLength } from "@/validations/address";

export const formSchemaPersonal = yup.object<{}, Shape<CustomerCardPersonalFormType>>({
    lastName: yup.string().required(),
    street: yup.string().max(AddressMaxLength.Street).required(),
    houseNumber: yup.string().max(AddressMaxLength.HouseNumber).required(),
    boxNumber: yup.string().max(AddressMaxLength.BoxNumber),
    zipCode: yup.string().max(AddressMaxLength.ZipCode).required(),
    city: yup.string().max(AddressMaxLength.City).required(),
    additionalInfo: yup.string(),
    country: yup.object({
        id: yup.string().required(),
    }),
});

export const formSchemaPersonalPhysical = yup.object<{}, Shape<CustomerCardPersonalFormType>>({
    title: yup.object({
        id: yup.string(),
    }),
    firstName: yup.string().required(),
    birthdate: yup.date().required().birthdate().nullable(),
    civilState: yup.object({
        id: yup.string().required(),
    }),
});

export const formSchemaIdentityCard = yup.object<{}, Shape<CustomerCardIdentityFormType>>({
    idNumber: yup.string().requiredIf(["validFrom", "validTo"]),
    nationalRegistryNumber: yup.string().exactLength(11),
    validFrom: yup.date().presentOrPast().requiredIf(["idNumber", "validTo"]).nullable(),
    validTo: yup.date().onFuture().requiredIf(["idNumber", "validFrom"]).nullable(),
    issuedBy: yup.string(),
});

export const formSchemaDriverLicense = yup.object<{}, Shape<CustomerCardDriverLicenseFormType>>({
    validUntil: yup.date().onFuture().nullable(),
});

export const formSchemaPhysicalDetails = yup.object<{}, Shape<CustomerCardFormType>>({
    identity: yup.object().when("isPhysicalPerson", {
        is: true,
        then: () => formSchemaIdentityCard,
    }),
    driverLicense: yup.object().when("isPhysicalPerson", {
        is: true,
        then: () => formSchemaDriverLicense,
    }),
});
